import baseUrl from './baseUrl'

export default {
  action: {
    read: 'read',
    permissionLogin: 'allow',
  },

  resource: {
    auth: 'Auth',
    user: 'client',
  },

  // BASEURL
  baseUrl: baseUrl.ApiBaseUrl,
  serverBaseUrl: baseUrl.serverBaseUrl,
  debtiaappUrl: baseUrl.debtiaappUrl,
  economicRedirectUrl: baseUrl.economicRedirectUrl,
  dineroRedirectUrl: baseUrl.dineroRedirectUrl,

  // Support
  supportPhone: '+45 44 22 40 00',
  supportEmail: 'info@debtia.dk',
}
